import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dashboardService } from "../../../services/dashboardService";
import type { Dashboard } from "../../../types";

export const useUpdateDashboard = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      dashboardId,
      dashboard,
    }: {
      dashboardId: string;
      dashboard: Partial<Omit<Dashboard, "id">>;
    }) => {
      const updated = await dashboardService.patch(dashboardId, dashboard);
      return { updated, dashboardId };
    },
    onSuccess: ({ updated, dashboardId }) => {
      qc.setQueryData(["dashboard", updated.id], updated);
      qc.invalidateQueries({ queryKey: ["dashboard", dashboardId] });
      qc.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
};
